import {Component, inject, OnInit, signal} from '@angular/core';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {AuthService} from '@services/auth.service';

@Component({
  selector: 'app-verify-email',
  imports: [RouterLink],
  templateUrl: './verify-email.html',
})
export class VerifyEmail implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);

  status = signal<'loading' | 'success' | 'error'>('loading');
  message = signal('Vérification en cours...');

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (!token) {
      this.status.set('error');
      this.message.set('Lien de vérification invalide.');
      return;
    }

    this.authService.verifyEmail(token).subscribe({
      next: (res) => {
        this.status.set('success');
        this.message.set(res.message);
      },
      error: (err) => {
        this.status.set('error');
        const body = err.error;
        this.message.set(
          typeof body === 'string' && body.length > 0
            ? body
            : 'Le lien de vérification est invalide ou a expiré.'
        );
      },
    });
  }
}
